import { render, staticRenderFns } from "./scrollItem.vue?vue&type=template&id=f15dbb04&scoped=true&"
import script from "./scrollItem.vue?vue&type=script&lang=js&"
export * from "./scrollItem.vue?vue&type=script&lang=js&"
import style0 from "./scrollItem.vue?vue&type=style&index=0&id=f15dbb04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15dbb04",
  null
  
)

export default component.exports